import React, { useState } from 'react';
import BasicModal from '../../newStudent/Modal/BasicModal';
import { IChatUser } from '../../../interfaces/chat/chat.interface';
import { HiUserGroup, HiSearch, HiX } from 'react-icons/hi';
import * as S from './styles';
import { ButtonSimple } from '../../newStudent/Buttons';
import HeaderModal from '../../agent/HeaderModal';

interface IParticipantSelectorModalProps {
  isOpen: boolean;
  onClose: () => void;
  users: IChatUser[];
  onSelectParticipants: (participantIds: number[]) => Promise<void>;
}

export default function ParticipantSelectorModal({
  isOpen,
  onClose,
  users,
  onSelectParticipants,
}: IParticipantSelectorModalProps) {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedUsers, setSelectedUsers] = useState<number[]>([]);

  const filteredUsers = users.filter((user) =>
    user.name.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const handleSelectUser = (userId: number) => {
    setSelectedUsers((prev) => {
      if (prev.includes(userId)) {
        return prev.filter((id) => id !== userId);
      }
      return [...prev, userId];
    });
  };

  const handleAdd = async () => {
    if (selectedUsers.length > 0) {
      await onSelectParticipants(selectedUsers);
      onClose();
      setSearchTerm('');
      setSelectedUsers([]);
    }
  };

  const handleClose = () => {
    onClose();
    setSearchTerm('');
    setSelectedUsers([]);
  };

  const handleRemoveSelected = (userId: number) => {
    setSelectedUsers((prev) => prev.filter((id) => id !== userId));
  };

  const selectedUsersList = users.filter((user) => selectedUsers.includes(user.id));

  return (
    <BasicModal
      isOpen={isOpen}
      setIsOpen={() => handleClose()}
      handleOnClose={handleClose}
      isFloat
      zIndex={1100}
    >
      <S.Container>
        <HeaderModal
          setOpen={handleClose}
          title="Adicionar Participantes"
          subtitle
          icon={<HiUserGroup size={24} />}
          handleClose={() => handleClose()}
        />
        <S.Content>
          {selectedUsersList.length > 0 && (
            <S.SelectedUsers>
              <S.SelectedUsersLabel>Participantes selecionados:</S.SelectedUsersLabel>
              <S.SelectedUsersList>
                {selectedUsersList.map((user) => (
                  <S.SelectedUserTag key={user.id}>
                    <S.SelectedUserName>{user.name}</S.SelectedUserName>
                    <S.RemoveButton onClick={() => handleRemoveSelected(user.id)}>
                      <HiX size={14} />
                    </S.RemoveButton>
                  </S.SelectedUserTag>
                ))}
              </S.SelectedUsersList>
            </S.SelectedUsers>
          )}

          <S.Description>Selecione os participantes para adicionar ao grupo:</S.Description>

          <S.SearchWrapper>
            <S.SearchIcon>
              <HiSearch />
            </S.SearchIcon>
            <S.SearchInput
              type="text"
              placeholder="Buscar contato..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </S.SearchWrapper>

          <S.UserList>
            {filteredUsers.length === 0 ? (
              <S.EmptyState>
                <S.EmptyText>Nenhum contato encontrado</S.EmptyText>
              </S.EmptyState>
            ) : (
              filteredUsers.map((user) => {
                const isSelected = selectedUsers.includes(user.id);
                return (
                  <S.UserItem
                    key={user.id}
                    onClick={() => handleSelectUser(user.id)}
                    $isSelected={isSelected}
                  >
                    <S.AvatarContainer>
                      {user.avatar ? (
                        <S.Avatar src={user.avatar} alt={user.name} />
                      ) : (
                        <S.AvatarPlaceholder>
                          {user.name.charAt(0).toUpperCase()}
                        </S.AvatarPlaceholder>
                      )}
                      {user.isOnline === true ? (
                        <S.OnlineBadge />
                      ) : user.isOnline === false ? (
                        <S.OfflineBadge />
                      ) : null}
                    </S.AvatarContainer>

                    <S.UserInfo>
                      <S.UserName>{user.name}</S.UserName>
                      <S.UserStatus>{user.isOnline ? 'Online' : 'Offline'}</S.UserStatus>
                    </S.UserInfo>

                    <S.Checkbox $isSelected={isSelected}>
                      {isSelected && '✓'}
                    </S.Checkbox>
                  </S.UserItem>
                );
              })
            )}
          </S.UserList>

          <S.Footer>
            <ButtonSimple color="gray" font="p" widthSize="medium" onClick={handleClose}>
              Cancelar
            </ButtonSimple>
            <ButtonSimple color="primary" font="p" widthSize="medium" onClick={handleAdd} disabled={selectedUsers.length === 0}>
              Adicionar ({selectedUsers.length})
            </ButtonSimple>
          </S.Footer>
        </S.Content>
      </S.Container>
    </BasicModal>
  );
}

